module.exports = {"id":"s5-q2","text":"Do you have more than one email address?","multiselect":false,"options":[{"id":"s5-q2-a1","text":"Yes","next":"s5-q3","capability":3,"access":3,"focusarea":[0,4,0,0,0]},{"id":"s5-q2-a2","text":"No","next":"s5-q3","capability":0,"access":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s5-q2.json
// module id = 909
// module chunks = 41